import React from 'react';
import ReactDOM from 'react-dom';
import singleSpaReact from 'single-spa-react';
import merge from 'lodash-es/merge';
import Root from './web-app-header.js';
import i18next from './i18n';
import { overrides } from './theme';
import {
  Box as Wrapper,
  TonicProvider,
  useColorMode,
  theme,
} from '@tonic-ui/react';
import ErrorHandler from './components/error-handler';

const HeaderContainer = (props) => {
  const [colorMode] = useColorMode();
  const backgroundColor = {
    light: 'white',
    dark: 'gray:100',
  }[colorMode];
  const color = {
    light: 'black:primary',
    dark: 'white:primary',
  }[colorMode];

  return (
    <Wrapper
      backgroundColor={backgroundColor}
      color={color}
      fontSize="sm"
      lineHeight="sm"
      {...props}
    />
  );
};

const HeaderApp = (props) => {
  const customTheme = merge(theme, overrides);
  return (
    <TonicProvider
      colorMode={{ defaultValue: 'dark' }}
      useCSSBaseline={true}
      theme={customTheme}
    >
      <HeaderContainer>
        <Root {...props} />
      </HeaderContainer>
    </TonicProvider>
  );
};

const reactLifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: HeaderApp,
  errorBoundary(err, info, props) {
    return <ErrorHandler />;
  },
});

export function bootstrap(props) {
  // console.log('Top Header Bar to be bootstraped');
  return reactLifecycles.bootstrap(props);
}

export function mount(props) {
  // console.log(`Top Header Bar to be mounted with props ${JSON.stringify(props)}`);
  return reactLifecycles.mount(props);
}

export function unmount(props) {
  // console.log('Top Header Bar to be unmounted');
  return reactLifecycles.unmount(props);
}
